var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShortenLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 3.75L12.75 1.75C13.75 0.75 15.75 0.75 16.75 1.75L17.75 2.75C18.75 3.75 18.75 5.75 17.75 6.75L12.75 11.75C11.75 12.75 9.75 12.75 8.75 11.75M8.75 15.75L6.75 17.75C5.75 18.75 3.75 18.75 2.75 17.75L1.75 16.75C0.75 15.75 0.75 13.75 1.75 12.75L6.75 7.75C7.75 6.75 9.75 6.75 10.75 7.75",
    stroke: "url(#paint0_linear_5_174)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_174",
    x1: 9.75,
    y1: 1,
    x2: 9.75,
    y2: 18.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5236AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E31937"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortenLogo);
export default __webpack_public_path__ + "static/media/Shorten-Logo.9f0abc8b9f3fb36a5811023f4011bd73.svg";
export { ForwardRef as ReactComponent };